import { SitePreviewConfig } from 'config/sitePreview';
import { SitePreviewCtaTarget, SitePreviewExperience } from './sitePreviewExperiences';

export interface OfferCardViewModel {
  urgencyKey?: string;
  discountKey?: string;
  discountPercent?: number;
  descriptionKey?: string;
  buttonKey: string;
  footerPrefixKey?: string;
  footerHighlightKey?: string;
}

export interface SitePreviewViewModel {
  ctaTarget: SitePreviewCtaTarget;
  titleKey: string;
  subtitleKey: string;
  couponCode?: string;
  showHalfOffImage: boolean;
  offerCard: OfferCardViewModel;
}

interface BuildSitePreviewViewModelParams {
  experience: SitePreviewExperience;
  config: SitePreviewConfig;
}

export function buildSitePreviewViewModel({
  experience,
  config,
}: BuildSitePreviewViewModelParams): SitePreviewViewModel {
  const { ctaTarget, content } = experience;
  const isPremiumCta = ctaTarget === 'premium';
  const discountPercent = isPremiumCta ? config.discountPercent : undefined;
  const couponCode = isPremiumCta ? config.couponCode || undefined : undefined;

  return {
    ctaTarget,
    titleKey: content.titleKey,
    subtitleKey: content.subtitleKey,
    couponCode,
    showHalfOffImage: discountPercent === 50,
    offerCard: {
      urgencyKey: content.offerCard.urgencyKey,
      discountKey: content.offerCard.discountKey,
      discountPercent,
      descriptionKey: content.offerCard.descriptionKey,
      buttonKey: content.offerCard.buttonKey,
      footerPrefixKey: content.offerCard.footerPrefixKey,
      footerHighlightKey: content.offerCard.footerHighlightKey,
    },
  };
}
